const deepCopy = (obj) => {
  let _obj = Array.isArray(obj) ? [] : {}
  for (let key in obj) {
    _obj[key] = typeof obj[key] === 'object' ? deepCopy(obj[key]) : obj[key]
  }
  return _obj
}

export default deepCopy
